import React from 'react';
import './App.css';
import Download from './screens/Download';

function App() {
  return <Download />;
}

export default App;
